import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const color = props.color || '#34189A'
  return (
    <svg
      width={12}
      height={12}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.096 7.258L3.25 5.413l-.569.569 2.414 2.413 4.21-4.21-.57-.568-3.64 3.641z"
        fill={color}
      />
    </svg>
  )
}

export default React.memo(SvgComponent)
